/**
 * @description config
 */
"use strict";
const env = process.env.NODE_ENV;

module.exports = {
    PHUB_ENDPOINT: process.env.PHUB_ENDPOINT,
    OPERATION_HUB_ENDPOINT:process.env.OPERATION_HUB_ENDPOINT,
    COMM_ENDPOINT: process.env.COMM_ENDPOINT,
    SOCKETHUB_ENDPOINT: process.env.SOCKETHUB_ENDPOINT,
    UPLOAD_ENDPOINT: process.env.UPLOAD_ENDPOINT,
    SANAR_SERVICES : process.env.SANAR_SERVICES
}


// WEBPACK FOOTER //
// ./src/config/index.js